import { george, pr, theme, ui } from "aaa";
import { CardWithIcon } from "components/common/CardWithIcon";
import { TopBackgroundColor } from "components/util/TopBackgroundColor";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { SIdentitySettingsRoutes } from "./SIdentitySettingsRoutes";


const getDeviceIcon = (variant: "PHONE" | "DESKTOP") => {
    switch (variant) {
        case "PHONE": return pr.IconPhone;
        case "DESKTOP": return pr.IconComputer;
        default: return null;
    }
};

export const SIdentitySettingsAddDeviceCategory = () => {
    const [selectedDevice, setSelectedDevice] = React.useState<"PHONE" | "DESKTOP" | null>(null);

    return (
        <george.LandingBackground>
            <TopBackgroundColor />
            <pr.HeaderBackground
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <img
                    src={require("../../../assets/illustration.svg")}
                    height={`${theme.HEADER_ICON_SIZE}px`}
                    alt=""
                />
            </pr.HeaderBackground>
            <div style={{ padding: 15, paddingTop: 20, paddingBottom: 2 * theme.ACTION_BUTTON_HEIGHT }}>
                <pr.LandingPageTitle style={{ textAlign: "center" }}>
                    {ui.__("sidentitySettings.addDevice.category.title")}
                </pr.LandingPageTitle>
                <br />
                <pr.P_14_CONTENT>
                    {ui.__("sidentitySettings.addDevice.category.text")}
                </pr.P_14_CONTENT>
                <pr.VFlex style={{ flexGrow: 1 }}>
                    <pr.HFlexCentered style={{ justifyContent: "space-evenly", marginTop: theme.MARGIN_LARGE }}>
                        {["PHONE" as "PHONE", "DESKTOP" as "DESKTOP"].map(variant => {
                            const isChecked = selectedDevice === variant;
                            const color = isChecked ? theme.customColors.georgeLightBlue : theme.customColors.georgeLightGrey;
                            const DeviceIcon = getDeviceIcon(variant);

                            return (
                                <div key={variant} style={{ textAlign: "center" }}>
                                    <CardWithIcon
                                        icon={(
                                            <div style={{ textAlign: "center" }}>
                                                {DeviceIcon && <DeviceIcon style={{ height: 30, width: 30, color }} />}
                                                <pr.P_14_CONTENT style={{ userSelect: "none", color }} >
                                                    {variant === "DESKTOP" && ui.__("common.desktop")}
                                                    {variant === "PHONE" && ui.__("common.smartphone")}
                                                </pr.P_14_CONTENT>
                                            </div>
                                        )}
                                        checked={isChecked}
                                        onClick={() => setSelectedDevice(variant)}
                                    />
                                    <pr.P_14_TITLE style={{ fontWeight: "bold", color: theme.themeColors.ui_blue, textTransform: "uppercase", marginTop: theme.MARGIN_SMALL }}>
                                        {ui.__("common.freeOfCharge")}
                                    </pr.P_14_TITLE>
                                </div>
                            );
                        })}

                    </pr.HFlexCentered>
                </pr.VFlex>
            </div>
            <george.ActionButton
                disableButton={!selectedDevice}
                messageId="sidentitySettings.addDevice.category.actionbutton.text"
                onClick={() => {
                    if (selectedDevice === "PHONE") {
                        pushRoute(SIdentitySettingsRoutes.ADD_DEVICE_SUMMARY);
                    } else if (selectedDevice === "DESKTOP") {
                        pushRoute(SIdentitySettingsRoutes.ADD_DESKTOP_DEVICE_INFO);
                    }
                }}
            />
        </george.LandingBackground>
    );
};


// WEBPACK FOOTER //
// ./src/components/loginManagement/sIdentitySettings/SIdentitySettingsAddDeviceCategory.tsx